import React from 'react';

export const StyleAnalysisCard = ({ data }: { data: string | any }) => {
    let content = data;

    if (typeof data === 'string') {
        try {
            content = JSON.parse(data);
        } catch {
            // Plain text fallback
        }
    }

    // Helper recursivo para renderizar valores
    const renderValue = (val: any): React.ReactNode => {
        if (val === null || val === undefined) return null;

        if (typeof val === 'string') {
            // Limpiar comillas extras si existen
            return val.replace(/^"|"$/g, '');
        }

        if (Array.isArray(val)) {
            return (
                <ul className="list-disc pl-4 space-y-1 mt-1">
                    {val.map((item, i) => (
                        <li key={i} className="pl-1">{renderValue(item)}</li>
                    ))}
                </ul>
            );
        }

        if (typeof val === 'object') {
            return (
                <div className="space-y-3 mt-2">
                    {Object.entries(val).map(([k, v]) => (
                        <div key={k} className="pl-3 border-l-2 border-purple-200">
                            <span className="font-semibold text-purple-700 block text-xs uppercase tracking-wider mb-1">
                                {k.replace(/_/g, ' ')}
                            </span>
                            <div className="text-purple-900/90">{renderValue(v)}</div>
                        </div>
                    ))}
                </div>
            );
        }

        return String(val);
    };

    // Si después del parse sigue siendo string simple
    if (typeof content !== 'object' || content === null) {
        return (
            <p className="text-sm text-purple-800 leading-relaxed italic whitespace-pre-wrap">
                "{String(content)}"
            </p>
        );
    }

    return (
        <div className="grid gap-3 max-h-[60vh] overflow-y-auto pr-2 custom-scrollbar">
            {Object.entries(content).map(([key, value]) => (
                <div key={key} className="bg-white/70 rounded-lg p-3 border border-purple-100 shadow-sm hover:shadow-md transition-shadow">
                    <h4 className="font-bold text-purple-900 text-sm mb-2 capitalize flex items-center gap-2 border-b border-purple-100 pb-2">
                        <span className="w-1.5 h-1.5 rounded-full bg-purple-500"></span>
                        {key.replace(/_/g, ' ')}
                    </h4>
                    <div className="text-sm text-purple-800 leading-relaxed">
                        {renderValue(value)}
                    </div>
                </div>
            ))}
        </div>
    );
};
